import {MantineThemeComponents} from '@mantine/styles/lib/theme/types/MantineTheme'
import {ValueOfRecord} from 'ramda'
import {getCommonInputStyles} from './common'

export function getMultiSelectStylesConfig(): ValueOfRecord<MantineThemeComponents> {
  return {
    styles: { input: getCommonInputStyles() },
  }
}
